import * as React from "react";
import { CustomVideoConsultationSettings } from "./VideoConsultationSettings";
import TextField from "../commons/components/noform/TextField";

interface CustomVideoConsultationPanelProps {
  settings: CustomVideoConsultationSettings;
  invalidRoomUrl: boolean;
  invalidHomeUrl: boolean;
  onChange: (settings: CustomVideoConsultationSettings) => void;
}

export default function CustomVideoConsultationPanel({
  settings,
  invalidRoomUrl,
  invalidHomeUrl,
  onChange,
}: CustomVideoConsultationPanelProps) {
  const { roomUrl, homeUrl } =
    settings == null ? { roomUrl: "http://", homeUrl: "http://" } : settings;
  const errorMessage =
    i18n["Page.Settings.Customisation.VideoConsultation.Enabled.Custom.Invalid.Url"];

  const onRoomUrlChange = (newValue: string) => {
    onChange({
      ...settings,
      roomUrl: newValue,
    } as CustomVideoConsultationSettings);
  };

  const onLoginUrlChange = (newValue: string) => {
    onChange({
      ...settings,
      homeUrl: newValue,
    } as CustomVideoConsultationSettings);
  };

  return (
    <div className={"video-consultation-custom-panel"}>
      <div className={"title"}>
        {i18n["Page.Settings.Customisation.VideoConsultation.Enabled.Custom.RoomUrl.Title"]}
      </div>
      <div>
        <TextField
          value={roomUrl}
          onChange={onRoomUrlChange}
          maxLength={255}
          errorMessage={invalidRoomUrl ? errorMessage : null}
        />
      </div>
      <div className={"title"}>
        {i18n["Page.Settings.Customisation.VideoConsultation.Enabled.Custom.HomeUrl.Title"]}
      </div>
      <div>
        <TextField
          value={homeUrl}
          onChange={onLoginUrlChange}
          maxLength={255}
          errorMessage={invalidHomeUrl ? errorMessage : null}
        />
      </div>
    </div>
  );
}
